import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {IUserAccessFeatureStockRules} from '../access';

//#region INTERFACE IFeatureStockItemRuleAdd
export interface IFeatureStockItemRuleAdd extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_ITEM_RULE_ADD_DEFAULT
export const _FEATURE_STOCK_ITEM_RULE_ADD_DEFAULT: Readonly<IFeatureStockItemRuleAdd & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockRulesItemRuleAdd,
  feature: NavigationPageEnum.StockRulesItemRuleAdd,
  ref: SettingsReferenceEnum.featureStockRulesStockItemRuleAdd,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureStockItemRuleEnable
export interface IFeatureStockItemRuleEnable extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_ITEM_RULE_ENABLE_DEFAULT
export const _FEATURE_STOCK_ITEM_RULE_ENABLE_DEFAULT: Readonly<IFeatureStockItemRuleEnable & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockRulesItemRuleEnable,
  feature: NavigationPageEnum.StockRulesItemRuleEnable,
  ref: SettingsReferenceEnum.featureStockRulesStockItemRuleEnable,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureStockItemRuleDisable
export interface IFeatureStockItemRuleDisable extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_ITEM_RULE_DISABLE_DEFAULT
export const _FEATURE_STOCK_ITEM_RULE_DISABLE_DEFAULT: Readonly<IFeatureStockItemRuleDisable & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockRulesItemRuleDisable,
  feature: NavigationPageEnum.StockRulesItemRuleDisable,
  ref: SettingsReferenceEnum.featureStockRulesStockItemRuleDisable,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureStockTags
export interface IFeatureStockTags extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_TAGS_DEFAULT
export const _FEATURE_STOCK_TAGS_DEFAULT: Readonly<IFeatureStockTags & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockTags,
  feature: NavigationPageEnum.StockTags,
  ref: SettingsReferenceEnum.featureStockRulesStockTags,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeaturePriceThresholds
export interface IFeaturePriceThresholds extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_PRICE_THRESHOLDS_DEFAULT
export const _FEATURE_PRICE_THRESHOLDS_DEFAULT: Readonly<IFeaturePriceThresholds & Object> = {
  displayText: NavigationPageEnumHumanReadable.PriceThresholds,
  feature: NavigationPageEnum.PriceThresholds,
  ref: SettingsReferenceEnum.featureStockRulesStockThreshold,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeaturePriceBanding
export interface IFeaturePriceBanding extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_PRICE_BANDING_DEFAULT
export const _FEATURE_PRICE_BANDING_DEFAULT: Readonly<IFeaturePriceBanding & Object> = {
  displayText: NavigationPageEnumHumanReadable.PriceBanding,
  feature: NavigationPageEnum.PriceBanding,
  ref: SettingsReferenceEnum.featureStockRulesPriceBanding,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureMultiplePriceChanges
export interface IFeatureMultiplePriceChanges extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_MULTIPLE_PRICE_CHANGES_DEFAULT
export const _FEATURE_MULTIPLE_PRICE_CHANGES_DEFAULT: Readonly<IFeatureMultiplePriceChanges & Object> = {
  displayText: NavigationPageEnumHumanReadable.MultiplePriceChanges,
  feature: NavigationPageEnum.MultiplePriceChanges,
  ref: SettingsReferenceEnum.featureStockRulesMultiplePriceChanges,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureAdvancedFilters
export interface IFeatureAdvancedFilters extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_ADVANCED_FILTERS_DEFAULT
export const _FEATURE_ADVANCED_FILTERS_DEFAULT: Readonly<IFeatureAdvancedFilters & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockRulesAdvancedFilters,
  feature: NavigationPageEnum.StockRulesAdvancedFilters,
  ref: SettingsReferenceEnum.featureStockRulesAdvancedFilters,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureStockRules
export interface IFeatureStockRules extends IUserAccessFeature, Object {
  crudAccess: { [storeId: string]: IUserAccessFeatureStockRules };
}

//#endregion

//#region CONST _FEATURE_STOCK_RULES_DEFAULT
export const _FEATURE_STOCK_RULES_DEFAULT: Readonly<IFeatureStockRules & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockRules,
  feature: NavigationPageEnum.StockRules,
  ref: SettingsReferenceEnum.applicationUserTableSettings,
  standalone: false,
  subFeatures: [
    {..._FEATURE_STOCK_ITEM_RULE_ADD_DEFAULT},
    {..._FEATURE_STOCK_ITEM_RULE_ENABLE_DEFAULT},
    {..._FEATURE_STOCK_ITEM_RULE_DISABLE_DEFAULT},
    {..._FEATURE_PRICE_THRESHOLDS_DEFAULT},
    {..._FEATURE_PRICE_BANDING_DEFAULT},
    {..._FEATURE_MULTIPLE_PRICE_CHANGES_DEFAULT},
    {..._FEATURE_STOCK_TAGS_DEFAULT},
    {..._FEATURE_ADVANCED_FILTERS_DEFAULT},
  ],
  crudAccess: {},
};
//#endregion
